import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const PrivateRoute = () => {
    const { isAuth } = useAuth()
    return isAuth() ? <div>
        <div className='px-3 pt-1 flex divide-x bg-white'
            style={{ minHeight: 'calc(100vh - 100px)' }}
        >
            <div className='grow' style={{ width: '100%', maxWidth: `calc(100vw - 2.2rem)` }}>
                <Outlet />
            </div>
        </div>

    </div> : <Navigate to="/login" />;
}

export default PrivateRoute
